import React, { useState } from 'react';
import { X, Check, Minus, Plus } from 'lucide-react';

export default function HabitCheckInModal({ habit, onSave, onClose }) {
  const [value, setValue] = useState(habit.tracking?.currentTarget || 1);
  const [rating, setRating] = useState(null);

  const min = habit.tracking?.minimumTarget || 1;
  const unit = habit.tracking?.unitLabel || '';

  return (
    <div className="fixed inset-0 bg-black/50 flex items-end sm:items-center justify-center z-50" onClick={onClose}>
      <div className="bg-white rounded-t-2xl sm:rounded-2xl w-full sm:max-w-sm p-5 space-y-4" onClick={e => e.stopPropagation()}>
        <div className="flex items-center justify-between">
          <h3 className="font-semibold text-slate-800">{habit.title}</h3>
          <button onClick={onClose} className="p-1 text-slate-400 hover:text-slate-600 rounded">
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Value selector */}
        <div className="text-center space-y-2">
          <p className="text-xs text-slate-500">Wie viele {unit}?</p>
          <div className="flex items-center justify-center gap-4">
            <button
              onClick={() => setValue(Math.max(min, value - 1))}
              className="w-10 h-10 rounded-full bg-slate-100 hover:bg-slate-200 flex items-center justify-center"
              data-testid="checkin-minus"
            >
              <Minus className="w-5 h-5 text-slate-600" />
            </button>
            <div className="text-center">
              <input
                type="number"
                value={value}
                min={min}
                onChange={e => {
                  const v = parseInt(e.target.value, 10);
                  if (!isNaN(v) && v >= min) setValue(v);
                  else if (e.target.value === '') setValue('');
                }}
                onBlur={e => {
                  const v = parseInt(e.target.value, 10);
                  if (isNaN(v) || v < min) setValue(min);
                }}
                className="w-24 text-3xl font-bold text-slate-800 text-center bg-transparent border-b-2 border-slate-200 focus:border-emerald-500 outline-none transition-colors"
                data-testid="checkin-value"
              />
              {unit && <span className="text-sm text-slate-500 ml-1">{unit}</span>}
            </div>
            <button
              onClick={() => setValue(value + 1)}
              className="w-10 h-10 rounded-full bg-emerald-100 hover:bg-emerald-200 flex items-center justify-center"
              data-testid="checkin-plus"
            >
              <Plus className="w-5 h-5 text-emerald-600" />
            </button>
          </div>
          <p className="text-xs text-slate-400">Min: {min} {unit} (1%-Version)</p>
        </div>

        {/* Rating chips */}
        <div className="space-y-1">
          <p className="text-xs text-slate-500 text-center">Wie war's?</p>
          <div className="flex gap-2 justify-center">
            {[
              { key: 'easy', label: 'Leicht', color: 'bg-emerald-100 text-emerald-700 border-emerald-300' },
              { key: 'ok', label: 'OK', color: 'bg-amber-100 text-amber-700 border-amber-300' },
              { key: 'hard', label: 'Schwer', color: 'bg-red-100 text-red-700 border-red-300' }
            ].map(r => (
              <button
                key={r.key}
                onClick={() => setRating(rating === r.key ? null : r.key)}
                className={`px-4 py-1.5 rounded-full text-sm font-medium border transition-all ${
                  rating === r.key ? r.color + ' ring-2 ring-offset-1 ring-current' : 'bg-white text-slate-500 border-slate-200'
                }`}
                data-testid={`rating-${r.key}`}
              >
                {r.label}
              </button>
            ))}
          </div>
        </div>

        {/* Save */}
        <button
          onClick={() => onSave(value, rating)}
          className="w-full py-3 bg-emerald-600 hover:bg-emerald-700 text-white font-semibold rounded-xl transition-colors flex items-center justify-center gap-2"
          data-testid="checkin-save"
        >
          <Check className="w-5 h-5" />
          Erledigt
        </button>
      </div>
    </div>
  );
}
